export default __webpack_public_path__ + "static/apple-store-ebb196c3a183361b964bf9950c157456.png";